import { render, staticRenderFns } from "./SecurityPanel.vue?vue&type=template&id=72f7d1aa&scoped=true&"
import script from "./SecurityPanel.vue?vue&type=script&lang=js&"
export * from "./SecurityPanel.vue?vue&type=script&lang=js&"
import style0 from "./SecurityPanel.vue?vue&type=style&index=0&id=72f7d1aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f7d1aa",
  null
  
)

export default component.exports